import React, { Fragment, useEffect, useState } from 'react'
import PageTitle from '../../layouts/PageTitle'
import Select from "react-select";
import { useCallback } from "react";
import useRazorpay from "react-razorpay";


import countries from '../../../mock/countries.json';
import { Button } from 'react-bootstrap';
import swal from 'sweetalert';
import { addDonation, getCampaignOptions, getEventTypes, getPaymentMethods, paymentConfirm, paymentConfirmIppopay, trigerMails } from '../../../helper/BackendHelper';
import { useHistory } from 'react-router-dom';
import PageLoader from '../../layouts/PageLoader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DonerSelect from '../../components/Common/DonerSelect';
import moment from 'moment';
import SelectCampaignWithEvent from '../../components/Common/SelectCampaignWithEvent';
import PludgeMeal from '../../components/Common/PludgeMeal';
import { notifyError } from '../../../helper/notification';
import { Ippopay } from 'react-ippopay';

const initialData = {};

const paymentMethodSInitial = [
    {
        "value": 1,
        "lable": "Online"
    },
    {
        "value": 2,
        "lable": "UPI"
    },
    {
        "value": 3,
        "lable": "Cheque"
    },
    {
        "value": 4,
        "lable": "Wire Transfer"
    }
]

const DonetionAdd = () => {

    // console.log({countries});
    const Razorpay = useRazorpay();
    const [formData, setformData] = useState({ ...initialData, amount: '' });
    const [campaignData, setCampaignData] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [isEvent, setIsEvent] = useState(false);
    const [eventDate, setEventDate] = useState(new Date());
    const [paymentMethods, setPaymentMethods] = useState(paymentMethodSInitial);
    const [paymentOptions, setPaymentOptions] = useState([])
    const [eventTypes, setEventTypes] = useState([])
    const [eventOptions, setEventOptions] = useState([])
    const [isMealOpen, setIsMealOpen] = useState(false);

    const [isIppopayOpen, setIsIppopayOpen] = useState(false);
    const [ippopayOrderId, setIppopayOrderId] = useState();

    const [isCampaign, setIsCampaign] = useState(true);
    const [isMilestone, setIsMilestone] = useState(false);
    const [isMagicpot, setIsMagicpot] = useState(false);
    const [isMagicpotPayment, setMagicpotPayment] = useState(false);
    
    const [userSelect, setUserSelect] = useState(false);
    const [selectedUser, setSelectedUser] = useState();

    const [isPaymentOption, setIsPaymentOption] = useState(false);

    const [isConnectdhan, setConnectdhan] = useState(false);

    const [dhanContainers, setDhanContainers] = useState([]);
    const [quickDhanAmount, setQuickDhanAmount] = useState('');

    const router = useHistory();

    const onChangeValue = (e) => {
        setformData({ ...formData, [e?.currentTarget?.name]: e?.currentTarget?.value })
    }

    const countriesOptions = countries.map((country) => ({
        value: country.name,
        label: country.name,
    }))

    const onDonerSelect = (data) => {

        let donerData = {
            "name": data?.name,
            "email": data?.email,
            "address": data?.address?.address,
            "city": data?.address?.city,
            "pincode": data?.address?.pincode,
            "country": data?.address?.country,
            "phone": data?.phone,
            "pan": data?.pan,
            "whatsapp": data?.whatsapp
        }

        setformData({ ...formData, ...donerData })

    }

    useEffect(() => {
        setIsLoading(true);
        initialLoad().then(() => setIsLoading(false))
        if (window) {
            window.addEventListener('message', ippopayHandler);
        }

    }, [])

    const initialLoad = async () => {
        getPaymentMethods().then((res) => {
            if (res?.status === "success") {
                let data = res?.data;
                data?.shift();
                setPaymentMethods(data)
            }
        })
        getEventTypes().then((res) => {
            if (res?.status === "success") {
                setEventTypes(res?.data)
            }
        })

        getCampaignOptions().then((res) => {

            if (res?.status == "success") {
                setCampaignData(res?.data)
            }

        })
    }

    useEffect(() => {
        setPaymentOptions(paymentMethods.map((payment) => ({
            value: payment.lable,
            label: payment.lable,
        })))

    }, [paymentMethods])

    useEffect(() => {
        setEventOptions(eventTypes.map((eventType) => ({
            value: eventType.lable,
            label: eventType.lable,
        })))

    }, [eventTypes])

    useEffect(() => {
        if (isEvent && !isCampaign && !isMagicpotPayment) {
            setformData({ ...formData, event_date: moment(eventDate).format("YYYY-MM-DD"), event: null })
        }
    }, [isEvent, isCampaign, isMagicpotPayment, isConnectdhan])

    useEffect(() => {
        const quickDhanAmount = 0;
        if(dhanContainers.length > 0){
            const totalAmount = dhanContainers.reduce((sum, dhan) => {
                return sum + (dhan.amount ? parseFloat(dhan.amount) : 0);
            }, quickDhanAmount);
            setformData({ ...formData, amount: totalAmount.toString() });
        }
    }, [dhanContainers]);  // Dependency array to run effect whenever `dhanContainers` change

    const formSubmit = async (e) => {
        e.preventDefault();

        setIsLoading(true);

        // Calculate total amount including all Connect Dhan dhans if isConnectdhan is true
        let finalFormData = { ...formData };
        if (isConnectdhan && dhanContainers.length > 0) {
            const dhanAmountsTotal = dhanContainers.reduce((sum, dhan) => {
                return sum + (dhan.amount ? parseFloat(dhan.amount) : 0);
            }, 0);
            finalFormData.amount = dhanAmountsTotal.toString();
            // Include all Connect Dhan containers in the form data
            finalFormData.connectDhan = dhanContainers;
        }

        const res = await addDonation(finalFormData);

        if (res?.status === 'success') {

            if (res?.data?.onlinePayment) {

                // handlePayment(res?.data?.donation);
                handleIppopayPayment(res?.data?.donation);

            } else {
                swal(`Donations added`, ``, "success")
                setIsLoading(false);
                router.push('/list-of-donations')
                trigerMails();
            }

        } else {

            if (res.isAxiosError) {

                if (res?.response?.data?.errors) {
                    Object.values(res?.response?.data?.errors).map((errors) => errors.map((error) => notifyError(error)))
                } else {
                    notifyError(res?.response?.data?.message)
                }
            } else {
                swal("Oops", `${res?.response?.data?.message ? res?.response?.data?.message : res?.message}`, "error")
            }
            setIsLoading(false);
        }
    }

    const onEventDateSelect = (date) => {

        setEventDate(new Date(date))
        setformData({ ...formData, event_date: moment(date).format("YYYY-MM-DD") })
    }

    const handlePayment = useCallback(async (donation) => {

        // console.log({ donation });

        const options = {
            key: process.env.REACT_APP_RAZORPAY_API_KEY,
            amount: donation?.amount,
            currency: "INR",
            name: "Ech Kitchen",
            description: `I am pleased to pledge ₹${donation?.amount} towards Kathir Dhan.`,
            image: "https://www.ecokitchen.org/eco/kathirdhan/images/eco-kitchen-logo.jpg",
            order_id: donation?.payment?.order_id,
            handler: (res) => {
                // console.log(res);
                paymentConfirm(res?.razorpay_payment_id, donation).then((res) => {
                    if (res?.status === 'success') {
                        swal(`Donations added`, ``, "success")
                        setIsLoading(false);
                        router.push('/list-of-donations')
                    } else {

                        if (res.isAxiosError) {

                            if (res?.response?.data?.errors) {
                                Object.values(res?.response?.data?.errors).map((errors) => errors.map((error) => notifyError(error)))
                            } else {
                                notifyError(res?.response?.data?.message)
                            }
                        } else {
                            swal("Oops", `${res?.response?.data?.message ? res?.response?.data?.message : res?.message}`, "error")
                        }
                        setIsLoading(false);

                    }
                })
            },
            prefill: {
                name: donation?.donate_by?.name,
                email: donation?.donate_by?.email,
            },
            theme: {
                color: "#5c9c26",
            },
        };

        const rzpay = new Razorpay(options);
        rzpay.open();
    }, [Razorpay]);

    const ippopayHandler = (e) => {
        if (e.data.status == 'success') {
            paymentConfirmIppopay(e?.data?.order_id).then((res) => {
                if (res?.status === 'success') {
                    swal(`Donations added`, ``, "success")
                    router.push('/list-of-donations')
                    trigerMails();

                } else {

                    if (res.isAxiosError) {

                        if (res?.response?.data?.errors) {
                            Object.values(res?.response?.data?.errors).map((errors) => errors.map((error) => notifyError(error)))
                        } else {
                            notifyError(res?.response?.data?.message)
                        }
                    } else {
                        swal("Oops", `${res?.response?.data?.message ? res?.response?.data?.message : res?.message}`, "error")
                    }


                }
            })
        }
        if (e.data.status == 'failure') {
            console.log(e.data)
        }
    }

    const handleIppopayPayment = (donation) => {

        // console.log({ donation });
        setIsIppopayOpen(true);
        setIsLoading(false);
        setIppopayOrderId(donation?.payment?.order_id)

    };

    const onMealSelect = (data) => {
        if (data?.amount > 0 && data?.pax > 0) {
            setformData({ ...formData, meals: data, amount: data?.amount })
        }
    }

    const onAmountChange = (e) => {
        // setformData({ ...formData, meals: null, amount: e?.currentTarget?.value })
        setformData({ ...formData, amount: e?.currentTarget?.value })
    }

    const handleCampaignChange = (e) => {
        const isChecked = e.currentTarget.value === "true";
        console.log('handleCampaignChange',isChecked)
        setIsCampaign(isChecked);
        setIsMagicpot(false);
        setIsMilestone(false);
        setMagicpotPayment(false);
        setConnectdhan(false);
        checkConnectdhan();

        setformData({ ...formData, donation_path: 1 })
    };

    const handleMilestoneChange = (e) => {
        const isChecked = e.currentTarget.value === "true";
        console.log('handleMilestoneChange',isChecked)
        setIsMilestone(isChecked);
        setIsMagicpot(false);
        setIsCampaign(false);
        setMagicpotPayment(false);
        setConnectdhan(false);
        checkConnectdhan();
        setformData({ ...formData, donation_path: 2 })
    };

    const handleMagicpotChange = (e) => {
        const isChecked = e.currentTarget.value === "true";
        console.log('handleMagicpotChange',isChecked)
        setIsMagicpot(isChecked);
        setIsCampaign(false);
        setIsMilestone(false);

        setMagicpotPayment(false);
        setConnectdhan(false);
        checkConnectdhan();
        setformData({ ...formData, donation_path: 3 })
    };

    const handleConnectdhan = (e) => {
        const isChecked = e.currentTarget.value === "true";
        setIsMagicpot(false);
        setIsCampaign(false);
        setMagicpotPayment(false);
        setIsMilestone(false);
        setConnectdhan(isChecked);

        // Reset quick dhan amount when toggling Connect Dhan
        if (!isChecked)
            setQuickDhanAmount('');
        else
            setformData({ ...formData, amount: '' });
    };

    const checkConnectdhan = () => {
        if(dhanContainers.length > 0)
            setformData({ ...formData, amount: '' });
        setDhanContainers([]);
    }

    const enableEvent = (enabled) => {
        setIsEvent(enabled)
        checkConnectdhan()
        if(enabled)
            setformData({ ...formData, donation_path: 1 });
        else
            setformData({ ...formData, donation_path: 0 });
    }

    /* const setTotalAmount = (amt) => {
        let totalAmount = parseFloat(amt) || 0;
        if (dhanContainers.length > 0) {
            const dhanAmountsTotal = dhanContainers.reduce((sum, dhan) => {
                return sum + (dhan.dhanAmount ? parseFloat(dhan.dhanAmount) : 0);
            }, 0);
            totalAmount = totalAmount + dhanAmountsTotal;
        }
        console.log('Total Amount:', totalAmount);
        setformData({ ...formData, amount: totalAmount.toString() });
    } */

    /* const onDhanAmount = (e) => {
        const dhanAmount = parseFloat(e?.currentTarget?.value) || 0;
        setQuickDhanAmount(e?.currentTarget?.value); // Update state for controlled input
        //setTotalAmount(dhanAmount);
    } */


    const addMoreConnectDhan = () => {
        // Validate all required fields
        if (!eventDate) {
            notifyError('Please select a dhan date');
            return;
        }
        if (!quickDhanAmount || parseFloat(quickDhanAmount) <= 0) {
            notifyError('Please enter a valid dhan amount (greater than 0)');
            return;
        }

        const newContainer = {
            id: Date.now(),
            date: new Date(eventDate),
            amount: quickDhanAmount
        };

        // Calculate total amount with the new container being added
        const updatedContainers = [...dhanContainers, newContainer];
        const amount = updatedContainers.reduce((sum, dhan) => {
            return sum + (dhan.amount ? parseFloat(dhan.amount) : 0);
        }, 0);
        
        // Update containers and amount together
        setDhanContainers(updatedContainers);
        setformData({
            ...formData,
            amount: amount.toString(),
            //event_date: new Date(),
            event_date: '',
            event_type: null,
            event_name: '',
            event_description: '',
        });

        setEventDate('')

        // Clear the quick dhan amount input
        setQuickDhanAmount('');
    };

    const updateContainer = (dhanId, field, value) => {
        setDhanContainers(dhanContainers.map(dhan =>
            dhan.id === dhanId ? { ...dhan, [field]: value } : dhan
        ));
    };

    const removeDhanContainer = (dhanId) => {
        const updatedDhanContainers = dhanContainers.filter(dhan => dhan.id !== dhanId);
        setDhanContainers(updatedDhanContainers);
    };

   // console.log("Selected Payment Method:", process.env.REACT_APP_IPPOPAY_PUBLIC_KEY);

    // console.log({ formData });

    return (
        <Fragment>
            {
                ippopayOrderId &&
                (<Ippopay ippopayOpen={isIppopayOpen} ippopayClose={true} order_id={ippopayOrderId} public_key={process.env.REACT_APP_IPPOPAY_PUBLIC_KEY} />)
            }

            <PageLoader isLoading={isLoading} >
                {/* <PageTitle activeMenu="Doner" motherMenu="Add New Doner" /> */}
                <DonerSelect close={() => setUserSelect(false)} isOpen={userSelect} onSelelct={onDonerSelect} />
                <PludgeMeal close={() => setIsMealOpen(false)} isOpen={isMealOpen} onSelelct={onMealSelect} />

                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        <div className="card">
                            <div className="card-header container-fluid" style={{ display: "block" }}>
                                <div class="row">
                                    <div class="col-md-7">
                                        <h4 className="card-title">Donation Details</h4>
                                    </div>
                                    <div class="col-md-3 float-right">
                                        <button class="btn btn-primary"
                                            onClick={() => setUserSelect(true)}
                                        >Donation By Existing Donor</button>
                                    </div>
                                    <div class="col-md-2 float-right">
                                        <button class="btn btn-primary"
                                            onClick={() => setIsMealOpen(true)}
                                        >Add Meals</button>
                                    </div>

                                </div>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={formSubmit}>
                                        <fieldset disabled={isLoading}>
                                            {/*formData?.paymentMethod === 5 && (
                                            <div className="row">
                                                <div className="col-lg-6">
                                                <div className="form-group mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control input-default "
                                                        placeholder="UPI Type (Ex: Gpay, Phonepay)"
                                                        name='upi_type'
                                                        required={formData.paymentMethod === 5}
                                                        onChange={onChangeValue}
                                                        value={formData?.upi_type}
                                                    />
                                                </div>
                                                </div>
                                            
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control input-default "
                                                            placeholder="UPI Reference Id"
                                                            name='upi_reference_id'
                                                            required={formData.paymentMethod === 5}
                                                            onChange={onChangeValue}
                                                            value={formData?.upi_reference_id}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            ) */} 
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control input-default "
                                                            placeholder="Name"
                                                            name='name'
                                                            required
                                                            onChange={onChangeValue}
                                                            value={formData?.name}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="email"
                                                            className="form-control input-default "
                                                            placeholder="Email"
                                                            name='email'
                                                            required
                                                            onChange={onChangeValue}
                                                            value={formData?.email}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="number"
                                                            className="form-control input-default "
                                                            placeholder="Mobile Number"
                                                            name='phone'
                                                            required
                                                            onChange={onChangeValue}
                                                            value={formData?.phone}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="number"
                                                            className="form-control input-default "
                                                            placeholder="WhatsApp Number"
                                                            name='whatsapp'

                                                            onChange={onChangeValue}
                                                            value={formData?.whatsapp}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control input-default "
                                                            placeholder="PAN Number (optional)"
                                                            name='pan'
                                                            onChange={onChangeValue}
                                                            value={formData?.pan}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">

                                                        <Select

                                                            onChange={(data) => setformData({ ...formData, country: data?.value })}
                                                            options={countriesOptions}
                                                            style={{
                                                                lineHeight: "40px",
                                                                color: "#7e7e7e",
                                                                paddingLeft: " 15px",
                                                            }}
                                                            placeholder="Select Country"
                                                            name='country'
                                                            value={
                                                                countriesOptions.filter(option =>
                                                                    option.label === formData?.country)
                                                            }
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <textarea name="address" id="address" className="form-control input-default "
                                                            placeholder="Address" rows="5"
                                                            onChange={onChangeValue}
                                                            value={formData?.address}

                                                        >

                                                        </textarea>

                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control input-default "
                                                            placeholder="City"
                                                            name='city'
                                                            required
                                                            onChange={onChangeValue}
                                                            value={formData?.city}

                                                        />
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="number"
                                                            className="form-control input-default "
                                                            placeholder="Pincode"
                                                            name='pincode'
                                                            required
                                                            onChange={onChangeValue}
                                                            value={formData?.pincode}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="col-auto">

                                                        <div className="input-group mb-3">
                                                            <textarea name="message" id="message" className="form-control input-default "
                                                                placeholder="Comments" rows="5"
                                                                onChange={onChangeValue}
                                                            >

                                                            </textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="input-group mb-3">
                                                        <div className="radio">
                                                            <label className="form-check-label">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="isEvent"
                                                                    onChange={(e) => {
                                                                        enableEvent(e.currentTarget.checked)
                                                                    }}
                                                                />
                                                                <span className="label-text">Path of Payment</span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    {
                                                        isEvent && (
                                                            <div className="form-group mb-0">
                                                                <div className="radio">
                                                                    <label>
                                                                        <input type="radio" name="isCampaign" checked={isCampaign} value={true} 
                                                                        onChange={handleCampaignChange}
                                                                        // onChange={(e) => setIsCampaign(e.currentTarget.value === "true" ? true : false)}
                                                                    />  Campaign
                                                                    </label>
                                                                </div>
                                                                <div className="radio">
                                                                    <label>
                                                                        <input type="radio" name="isCampaign" checked={isMilestone && !isConnectdhan} value={true} 
                                                                        onChange={handleMilestoneChange}
                                                                        // onChange={(e) => setIsMilestone(e.currentTarget.value === "true" ? true : false)} 
                                                                        />  Milestones
                                                                    </label>
                                                                </div>
                                                                { /* <div className="radio">
                                                                    <label>
                                                                        <input type="radio" name="isCampaign" checked={!isCampaign} value={true} onChange={(e) => setIsCampaign(e.currentTarget.value === "true" ? true : false)} />  Magic pot
                                                                    </label>
                                                                     </div> */ }
                                                                <div className="radio">
                                                                    <label>
                                                                        <input type="radio" name="isCampaign" checked={isMagicpot} value={true} 
                                                                        onChange={handleMagicpotChange}
                                                                        // onChange={(e) => setIsCampaign(e.currentTarget.value === "magicpot" ? 'magicpot' : '')} 
                                                                        />  Magicpot
                                                                    </label>
                                                                </div>

                                                                <div className="radio">
                                                                    <label>
                                                                        <input type="radio" name="isConnectdhan" checked={isConnectdhan} value={true} 
                                                                        onChange={handleConnectdhan}
                                                                        />  Connect Dhan
                                                                    </label>
                                                                </div>

                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            { (isEvent) && (<>
                                                {
                                                    isCampaign && isCampaign!='' && !isMagicpotPayment ? (<SelectCampaignWithEvent onSelect={(data) => setformData({ ...formData, ...data })} campaignData={campaignData} />) : 
                                                    (!isMagicpotPayment && !isConnectdhan) ?
                                                    (
                                                        <>
                                                            <div className="row">
                                                                <div className={`col-lg-${isConnectdhan?'4':'6'}`}>
                                                                    <label htmlFor="">Select Event Date</label>
                                                                    <div className="form-group mb-3">
                                                                        <DatePicker className="form-control" selected={eventDate} onSelect={onEventDateSelect} placeholderText="Select Event Date" dateFormat="yyyy-MM-dd" name='event_date' />
                                                                    </div>
                                                                </div>
                                                                <div className={`col-lg-${isConnectdhan?'4':'6'}`}>
                                                                    <div className="form-group mb-3">
                                                                        <label htmlFor="">Occasion detail</label>
                                                                        <Select
                                                                            // defaultValue={selectedOption}
                                                                            onChange={(data) => setformData({ ...formData, event_type: eventTypes.find((item) => item?.lable == data.value)?.value })}
                                                                            options={eventOptions}
                                                                            style={{
                                                                                lineHeight: "40px",
                                                                                color: "#7e7e7e",
                                                                                paddingLeft: " 15px",
                                                                            }}
                                                                            placeholder="Occasion detail"
                                                                            name='event_type'
                                                                            value={
                                                                                formData?.event_type 
                                                                                    ? eventOptions.find(opt => opt.value === eventTypes.find(e => e.value === formData?.event_type)?.lable) 
                                                                                    : null
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-lg-6">
                                                                    <div className="form-group">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control input-default "
                                                                            placeholder={formData?.event_type === 2 ? "Name of the person" : "Name of the person"}
                                                                            name='event_name'
                                                                            required={isConnectdhan ? false : true}
                                                                            onChange={onChangeValue}
                                                                            value={formData?.event_name}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6">
                                                                    <div className="form-group mb-3">
                                                                        <textarea name="event_description" id="event_description" className="form-control input-default "placeholder={`Describe about ${formData?.event_type === 2 ? "Person" : "person"} `} rows="5" onChange={onChangeValue} value={formData?.event_description}>
                                                                        </textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ):null
                                                }
                                                {(isConnectdhan) ?
                                                    (
                                                        <>
                                                            <div className="col-lg-12">
                                                                <div className="form-group mb-3">
                                                                    <label htmlFor="">Detail of connect dhan</label>
                                                                    <textarea name="event_description" id="event_description" className="form-control input-default "placeholder="Details about connect dhan" rows="4" onChange={onChangeValue} value={formData?.event_description}>
                                                                    </textarea>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className={`col-lg-6`}>
                                                                    <label htmlFor="">Select Dhan Date</label>
                                                                    <div className="form-group mb-3">
                                                                        <DatePicker className="form-control" selected={eventDate} onSelect={onEventDateSelect} placeholderText="Select Dhan Date" dateFormat="yyyy-MM-dd" name='event_date' />
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-4">
                                                                    <div className="col-auto">
                                                                        <label>Dhan Amount</label>
                                                                        <div className="input-group mb-3">
                                                                            <div className="input-group-text">₹</div>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                placeholder="Amount"
                                                                                name='amount'
                                                                                onChange={(e) => setQuickDhanAmount(e.target.value)}
                                                                                value={quickDhanAmount}
                                                                                min="1"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6">
                                                                    <Button 
                                                                        onClick={addMoreConnectDhan}
                                                                        className="mb-3 btn-primary"
                                                                        disabled={!formData?.event_date || !quickDhanAmount}
                                                                    >
                                                                        <i className="flaticon-381-plus"></i> Add More Dhan
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                            {dhanContainers.length > 0 && (
                                                                <div className="row">
                                                                    <div className="col-lg-12">
                                                                        <h4>Added Connect Dhan(s)</h4>
                                                                        {/* {dhanContainers.map((dhan, index) => (
                                                                            <div key={dhan.id} className="connect-dhan card mb-3" style={{borderLeft:'2px solid #17a2b8'}}>
                                                                                <div className="card-header bg-light">
                                                                                    <span><strong>Connect Dhan #{index + 1}</strong></span>
                                                                                    <button
                                                                                    type="button"
                                                                                    className="btn btn-danger btn-sm"
                                                                                    onClick={() => removeDhanContainer(dhan.id)}
                                                                                    ><i className="flaticon-381-trash-1"></i> Remove</button>
                                                                                </div>
                                                                                <div className="card-body p-3">
                                                                                    <div className="row">
                                                                                        <div className="col-lg-4">
                                                                                            <label htmlFor="">Select Event Date</label>
                                                                                            <div className="form-group mb-3">
                                                                                                <DatePicker 
                                                                                                    className="form-control" 
                                                                                                    selected={dhan.eventDate} 
                                                                                                    onChange={(date) => updateContainer(dhan.id, 'eventDate', date)}
                                                                                                    placeholderText="Select Event Date" 
                                                                                                    dateFormat="yyyy-MM-dd" 
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-lg-4">
                                                                                            <div className="form-group mb-3">
                                                                                                <label htmlFor="">Occasion detail</label>
                                                                                                <Select
                                                                                                    onChange={(data) => updateContainer(dhan.id, 'event_type', eventTypes.find((item) => item?.lable == data.value)?.value)}
                                                                                                    options={eventOptions}
                                                                                                    style={{
                                                                                                        lineHeight: "40px",
                                                                                                        color: "#7e7e7e",
                                                                                                        paddingLeft: " 15px",
                                                                                                    }}
                                                                                                    placeholder="Occasion detail"
                                                                                                    value={
                                                                                                        eventOptions.find(opt => opt.value === eventTypes.find(e => e.value === dhan.event_type)?.lable) || null
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="col-lg-4">
                                                                                            <div className="form-group mb-3">
                                                                                                <label htmlFor="">Dhan Amount</label>
                                                                                                <div className="input-group">
                                                                                                    <div className="input-group-text">₹</div>
                                                                                                    <input
                                                                                                        type="number"
                                                                                                        className="form-control"
                                                                                                        placeholder="Amount"
                                                                                                        value={dhan.dhanAmount || ''}
                                                                                                        onChange={(e) => updateContainer(dhan.id, 'dhanAmount', e.target.value)}
                                                                                                        min="1"
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                    <div className="row">
                                                                                        <div className="col-lg-6">
                                                                                            <div className="form-group mb-3">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control input-default"
                                                                                                    placeholder="Name of the person"
                                                                                                    value={dhan.event_name || ''}
                                                                                                    onChange={(e) => updateContainer(dhan.id, 'event_name', e.target.value)}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-lg-6">
                                                                                            <div className="form-group">
                                                                                                <textarea 
                                                                                                    className="form-control input-default"
                                                                                                    placeholder="Description"
                                                                                                    rows="3"
                                                                                                    value={dhan.event_description || ''}
                                                                                                    onChange={(e) => updateContainer(dhan.id, 'event_description', e.target.value)}
                                                                                                >
                                                                                                </textarea>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))} */}

                                                                        <table className="table table-bordered table-striped table-connect-dhan">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Dhan No.</th>
                                                                                    <th>Date</th>
                                                                                    <th>Amount</th>
                                                                                    <th>&nbsp;</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {dhanContainers.map( (dhan, index) => (<>
                                                                                    <tr key={dhan.id}>
                                                                                        <td>Dhan #{index + 1}</td>
                                                                                        <td>
                                                                                            <DatePicker
                                                                                                className="form-control"
                                                                                                selected={dhan.date}
                                                                                                onChange={(date) => updateContainer(dhan.id, 'date', date)}
                                                                                                placeholderText="Select Dhan Date"
                                                                                                dateFormat="yyyy-MM-dd"
                                                                                            />
                                                                                        </td>
                                                                                        <td>
                                                                                            <div className="input-group">
                                                                                                <div className="input-group-text">₹</div>
                                                                                                <input
                                                                                                type="number"
                                                                                                className="form-control"
                                                                                                placeholder="Amount"
                                                                                                value={dhan.amount || ''}
                                                                                                onChange={(e) => updateContainer(dhan.id, 'amount', e.target.value)}
                                                                                                min="1"
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-danger btn-sm"
                                                                                                onClick={() => removeDhanContainer(dhan.id)}>
                                                                                                <i className="flaticon-381-trash-1"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                </>))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    ):null
                                                }
                                            </>)}

                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="col-auto">
                                                        <label className="sr-only">Donation Amount</label>
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-text">₹</div>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Amount"
                                                                name='amount'
                                                                required
                                                                onChange={onAmountChange}
                                                                min="1"
                                                                disabled={isConnectdhan}
                                                                value={formData?.amount}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                    <Select
                                                        id="isPaymentOption"
                                                        /* onChange={(data) => {
                                                            console.log("Selected Payment Method:", data.value); // ✅ This will now show 1 or 2
                                                            setformData({ ...formData, paymentMethod: data.value });
                                                        }}*/
                                                        onChange={(data) => {
                                                            setformData({
                                                            ...formData, paymentMethod: paymentMethods.find((item) => item?.lable == data.value)?.value });
                                                        }}
                                                        options={paymentOptions} // Should be in { label, value } format
                                                        placeholder="Select Your Payment Method"
                                                        name="paymentMethod"
                                                        />
                                                    </div>
                                                </div> 
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <Button type='submit' variant="primary">{isLoading ? "Adding...." : "Add Donation"}</Button>

                                                </div>
                                            </div>
                                        </fieldset>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PageLoader>

        </Fragment>
    )
}

export default DonetionAdd